import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'
import { paginationCount } from '../constants/paginationCount/paginationCount'
import { is2w } from '../constants/vehicleTypeHelper'

const API_URL = process.env.REACT_APP_API_URL;

export const tutorialListAction = (page, search = '', type, id, category) => dispatch => {
  let url = `${API_URL}${Url.VEHICLE_TUTORIAL_LIST}?page=${page}&page_size=${paginationCount}`;

  if (id) {
    url += `&vehicle_ids=${id}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (type && type !== 'all') {
    url += `&type=${type}`;
  }
  if (category) {
    url += `&training_category_id=${category}`;
  }

  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({
        type: is2w() ? types.GET_TUTORIAL_LIST_2W : types.GET_RETRIVE_ALL_BANNER_IMAGE,
        payload: resp
      })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const fetchVehicles = () => dispatch => {
  const url = API_URL + Url.VEHICLE_CATEGORY_LIST
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_VEHICLE_CATEGORY_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const createContentAction = (params = {}) => async (dispatch) => {
  const url = API_URL + Url.CREATE_CONTENT
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  try {
    const response = await axios(options);
    if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        const errorData = error.response.data.error || error.response.data.errors;
        let errorMessage = '';
        if (errorData) {
          if (errorData.vehicle_ids) {
            errorMessage = errorData.vehicle_ids[0];
          } else if (errorData.mobile_number) {
            errorMessage = errorData.mobile_number[0];
          } else if (errorData.msr_id) {
            errorMessage = errorData.msr_id;
          } else if (errorData[0]?.type?.[0]) {
            errorMessage = errorData[0]?.type?.[0];
          } else if (errorData?.message) {
            errorMessage = errorData.message;
          } else {
            errorMessage = errorData;
          }
          if (errorMessage) {
            notify.error(errorMessage);
          }
        }
        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};

export const updateContentAction = (params = {}, id) => dispatch => {
  const url = `${API_URL}${Url.UPDATE_CONTENT}/${id}`
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null);
  options.headers = getHeadersformdata();
  options.url = url;

  return axios(options)
    .then(resp => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        return resp;
      } else {
        return null;
      }
    })
    .catch(error => {
      if (error.response && error.response.status === HTTP_STATUS.ERROR) {
        const responseData = error.response.data;
        if (responseData.error) {
          notify.error(responseData.error);
        }
        if (responseData.errors && responseData.errors.email) {
          notify.error(responseData.errors.email);
        }
        if (responseData.errors && responseData.errors.mobile_number) {
          notify.error(responseData.errors.mobile_number[0]);
        }
        return error.response;
      }
      errorHandler(error);
      return error.response;
    });
};

export const getContentDetails = (Id) => (dispatch) => {
  const url = `${API_URL}${Url.TRAINING_TUTORIAL_DETAILS}/${Id}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({
          type: is2w() ? types.GET_TUTORIAL_DETAILS_2W : types.GET_TUTORIAL_DETAILS,
          payload: resp?.data
        });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch content details");
    });
};

export const getVehiclesCategoryAction = () => (dispatch) => {
  const url = `${API_URL}${Url.VEHICLE_CATEGORY_LIST}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({ type: types.GET_VEHICLES_LIST, payload: resp?.data });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch vehicle categories");
    });
};

export const getVehiclesByCategoryAction = (categoryId) => (dispatch) => {
  const url = `${API_URL}${Url.VEHICLE_MODULE_LIST}?category_id=${categoryId}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url,
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({ type: types.GET_VEHICLES_LIST, payload: resp?.data });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch vehicles for the selected category");
    });
};

export const getVehiclesAction = () => (dispatch) => {
  const url = `${API_URL}${Url.MODULE_LIST}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({ type: types.GET_VEHICLES_LIST, payload: resp?.data });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch vehicles");
    });
};

export const getVehiclesAddContentAction = (categoryId) => (dispatch) => {
  let url = `${API_URL}${Url.VEHICLE_MODULE_LIST}`;
  if (categoryId) {
    url += `?category_id=${categoryId}`;
  }

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        if (!is2w()) {
          dispatch({ type: types.GET_VEHICLES_CONTENT_LIST, payload: resp?.data });
        }
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch vehicles");
    });
};

export const moduleListAction = (page, vehicleId = '', search = '', category = '') => dispatch => {
  let url = `${API_URL}${Url.MODULE_LIST}?page=${page}&page_size=10`;

  if (vehicleId) {
    url += `&vehicle_ids=${vehicleId}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (category) {
    url += `&training_category_id=${category}`;
  }

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then(resp => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({
          type: is2w() ? types.GET_MODULE_LIST_2W : types.GET_MODULE_LIST,
          payload: resp?.data
        });
        return resp;
      }
      return null;
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

export const addModuleAction = (params = {}) => (dispatch) => {
  const url = `${API_URL}${Url.ADD_MODULE}`;

  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null);
  options.headers = getHeaders();
  options.url = url;

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({
          type: is2w() ? types.POST_ADD_MODULE_2W : types.POST_ADD_MODULE,
          payload: resp
        });
        return resp;
      } else {
        return null;
      }
    })
    .catch((error) => {
      errorHandler(error);
    });
};

export const getModuleByIdAction = (id) => (dispatch) => {
  const url = `${API_URL}${Url.MODULE_BY_ID.replace("{id}", id)}`;

  const options = {
    method: "GET",
    headers: getHeaders(),
    url,
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({
          type: is2w() ? types.FETCH_MODULE_BY_ID_2W : types.FETCH_MODULE_BY_ID,
          payload: resp?.data
        });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      throw error;
    });
};

export const editModuleAction = (id, params) => (dispatch) => {
  const url = `${API_URL}${Url.EDIT_MODULE.replace("{id}", id)}`;
  const options = {
    method: "POST",
    headers: getHeaders(),
    url,
    data: params,
  };
  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.CREATED) {
        dispatch({
          type: is2w() ? types.POST_EDIT_MODULE_2W : types.POST_EDIT_MODULE,
          payload: resp
        });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      throw error;
    });
};

export const tutorialListAction2 = (type, id, search, page, fileType, trainingCategoryId, userTypeIds) => dispatch => {
  let url = `${API_URL}${Url.VEHICLE_TUTORIAL_LIST_SELECTED}?page=${page}&page_size=${paginationCount}`;

  if (id) {
    url += `&vehicle_ids=${id}`;
  }
  if (search) {
    url += `&search=${search}`;
  }
  if (type && type !== 'all') {
    url += `&type=${type}`;
  }
  if (fileType) {
    url += `&file_type=${fileType}`;
  }
  if (trainingCategoryId) {
    url += `&training_category_id=${trainingCategoryId}`;
  }
  if (userTypeIds && userTypeIds.length > 0) {
    userTypeIds.forEach(utId => {
      url += `&user_type_ids=${utId}`;
    });
  }

  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({
        type: is2w() ? types.GET_TUTORIAL_LIST_2W : types.GET_RETRIVE_ALL_BANNER_IMAGE,
        payload: resp
      })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

export const deleteContentAction = (id) => async (dispatch) => {
  if (!id) {
    notify.error('Content ID is required');
    return Promise.reject(new Error('Content ID is required'));
  }

  const url = `${API_URL}${Url.DELETE_CONTENT_2W}/${id}`;
  const options = {
    method: 'DELETE',
    headers: getHeaders(),
    url
  };

  try {
    const response = await axios(options);
    if (response?.status === 200 || response?.status === 204) {
      dispatch({ type: types.DELETE_CONTENT_2W, payload: { id } });
      notify.success(response?.data?.message || 'Content deleted successfully');
      return response;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const deleteModuleAction = (id) => async (dispatch) => {
  if (!id) {
    notify.error('Module ID is required');
    return Promise.reject(new Error('Module ID is required'));
  }

  const url = `${API_URL}${Url.DELETE_MODULE_2W}/${id}`;
  const options = {
    method: 'DELETE',
    headers: getHeaders(),
    url
  };

  try {
    const response = await axios(options);
    if (response?.status === 200 || response?.status === 204) {
      dispatch({ type: types.DELETE_MODULE_2W, payload: { id } });
      notify.success(response?.data?.message || 'Module deleted successfully');
      return response;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const getTrainingCategoryAction = () => (dispatch) => {
  const url = `${API_URL}${Url.TRAINING_CATEGORY}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({ type: types.GET_TRAINING_CATEGORY_LIST, payload: resp?.data });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch training categories");
    });
};

export const getTypeMasterListAction = () => (dispatch) => {
  const url = `${API_URL}${Url.TYPE_MASTER_LIST}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS) {
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch content types");
    });
};

export const getUserTypeListAction = () => (dispatch) => {
  const url = `${API_URL}${Url.USER_TYPE}`;

  let options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };

  return axios(options)
    .then((resp) => {
      if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
        dispatch({ type: types.GET_USER_TYPE_LIST, payload: resp?.data });
        return resp;
      }
      return null;
    })
    .catch((error) => {
      errorHandler(error);
      notify.error("Failed to fetch user types");
    });
};
